var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2876 7.74952L1.01463 0.857147H3.00189L2.73437 7.74952H1.2876ZM2.0028 11.1429C1.76258 11.1429 1.54602 11.0802 1.35312 10.955C1.16022 10.8337 1.00553 10.6693 0.88906 10.4618C0.77259 10.2505 0.714355 10.0176 0.714355 9.76321C0.714355 9.50881 0.77259 9.27789 0.88906 9.07045C1.00553 8.8591 1.16022 8.69276 1.35312 8.57143C1.54602 8.44619 1.76258 8.38357 2.0028 8.38357C2.23938 8.38357 2.45412 8.44619 2.64702 8.57143C2.84356 8.69276 2.99825 8.8591 3.11108 9.07045C3.22755 9.27789 3.28578 9.50881 3.28578 9.76321C3.28578 10.0176 3.22755 10.2505 3.11108 10.4618C2.99825 10.6693 2.84356 10.8337 2.64702 10.955C2.45412 11.0802 2.23938 11.1429 2.0028 11.1429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.edc9eeb3a4dfee048a89e9a0002e0a77.svg";
export { ForwardRef as ReactComponent };